var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 57.8868C46.2969 57.8868 57.8868 46.2969 57.8868 32C57.8868 17.7031 46.2969 6.11321 32 6.11321C17.7031 6.11321 6.11321 17.7031 6.11321 32C6.11321 46.2969 17.7031 57.8868 32 57.8868ZM32 60C47.464 60 60 47.464 60 32C60 16.536 47.464 4 32 4C16.536 4 4 16.536 4 32C4 47.464 16.536 60 32 60Z",
    fill: "#1A73E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7523 46.8313C37.0226 47.4134 36.7698 48.1046 36.1876 48.3749C33.497 49.6243 30.8314 49.8537 28.6473 48.8511C26.432 47.8343 24.9876 45.678 24.5132 42.7521L26.8078 42.3801C27.1911 44.7439 28.2739 46.122 29.617 46.7385C30.9915 47.3694 32.9158 47.3313 35.2086 46.2666C35.7908 45.9963 36.4819 46.2491 36.7523 46.8313Z",
    fill: "#1A73E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5849 35.1698V30.4151H35.6981V37.283H29.8868V35.1698H33.5849Z",
    fill: "#1A73E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7924 25.1321C46.7924 26.2992 45.8463 27.2453 44.6792 27.2453C43.5122 27.2453 42.566 26.2992 42.566 25.1321C42.566 23.965 43.5122 23.0189 44.6792 23.0189C45.8463 23.0189 46.7924 23.965 46.7924 25.1321Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.434 25.1321C21.434 26.2992 20.4878 27.2453 19.3208 27.2453C18.1537 27.2453 17.2076 26.2992 17.2076 25.1321C17.2076 23.965 18.1537 23.0189 19.3208 23.0189C20.4878 23.0189 21.434 23.965 21.434 25.1321Z",
    fill: "#1A73E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidFace);
export default __webpack_public_path__ + "static/media/Android Face.74449ecb421aadad46640e6a29752747.svg";
export { ForwardRef as ReactComponent };